import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const AlertasModal = ({ 
  openAlertDialog, 
  setOpenAlertDialog, 
  mostrarAlertas, 
  setMostrarAlertas, 
  alertas 
}) => {
  const renderAlertas = () =>
    alertas.map((alerta) => (
      <div key={alerta.id} className="alerta-popup">
        <Typography variant="h6">{alerta.proceso}</Typography>
        <Typography variant="body1">
          <strong>Estado:</strong> {alerta.estado}
        </Typography>
        <Typography variant="body1">
          <strong>Mensaje:</strong> {alerta.mensaje}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Creado el: {new Date(alerta.creacion).toLocaleString()}
        </Typography>
      </div>
    ))

  return (
    <>
      <Dialog
        open={openAlertDialog}
        onClose={() => setOpenAlertDialog(false)}
        maxWidth="md"
        style={{ padding: '20px' }}
      >
        <DialogTitle>Alertas</DialogTitle>
        <DialogContent>{renderAlertas()}</DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAlertDialog(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {mostrarAlertas && (
        <div className="floating-alert-box">
          <div className="floating-alert-header">
            <p
              style={{
                margin: '0',
                padding: '10px',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              Alertas
            </p>
            <IconButton onClick={() => setMostrarAlertas(false)} size="small">
              <CloseIcon color="#ffff" />
            </IconButton>
          </div>
          <div className="floating-alert-content">
            {alertas.map((alerta) => (
              <div key={alerta.id} style={{ marginBottom: '15px' }}>
                <Typography variant="body1">
                  <strong>Estado:</strong> {alerta.estado}
                </Typography>
                <Typography variant="body1">
                  <strong>Mensaje:</strong> {alerta.mensaje}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Creado el: {new Date(alerta.creacion).toLocaleString()}
                </Typography>

                <Typography variant="body2" color="textSecondary">
                  {alerta.actualizacion
                    ? `Actualizado el: ${new Date(
                        alerta.actualizacion,
                      ).toLocaleString()}`
                    : 'Sin actualizar'}
                </Typography>
                <hr />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default AlertasModal 